module.exports = __webpack_public_path__ + "img/Z82_05.fe259bd7.jpg";